/**
 * UUID v4 sinh ở client — APM-1302.
 *
 * ## ⚠️ Vì sao KHÔNG gọi thẳng `crypto.randomUUID()`
 *
 * `crypto.randomUUID` chỉ tồn tại ở **secure context**: `https://` hoặc
 * `localhost`. Mở dev server bằng **IP LAN** (`http://192.168.1.20:5210`) —
 * cách bình thường để xem app trên máy khác hoặc trên điện thoại — thì nó là
 * `undefined`, và lời gọi ném `TypeError`.
 *
 * Bắt được đúng như vậy khi kiểm tính năng này trên trình duyệt: `track()` ném
 * ngay dòng đầu, nên bảng theo dõi **không bao giờ mở ra** và người dùng chỉ
 * thấy một toast đỏ "Đã có lỗi xảy ra". Test không thấy gì: jsdom chạy ở
 * `http://localhost`, tức secure context, nên `randomUUID` có mặt.
 *
 * `crypto.getRandomValues` thì **không** bị chặn ở insecure context, nên bản dự
 * phòng vẫn dùng số ngẫu nhiên thật của trình duyệt — không phải `Math.random`.
 */
export function randomUuid(): string {
  if (typeof crypto.randomUUID === 'function') return crypto.randomUUID();

  const bytes = crypto.getRandomValues(new Uint8Array(16));
  // Phiên bản 4 và biến thể RFC 4122 — hai nhóm bit mà máy chủ dùng để nhận ra
  // đây là uuid hợp lệ (`z.uuid()` của Zod kiểm đúng chỗ này).
  bytes[6] = (bytes[6]! & 0x0f) | 0x40;
  bytes[8] = (bytes[8]! & 0x3f) | 0x80;

  const hex = [...bytes].map((byte) => byte.toString(16).padStart(2, '0')).join('');
  return [
    hex.slice(0, 8),
    hex.slice(8, 12),
    hex.slice(12, 16),
    hex.slice(16, 20),
    hex.slice(20),
  ].join('-');
}
